import { useEffect, useState } from "react";
import axios from "../helpers/axios";

export const createBottleReturn = async (values, callback) => {
  const res = await axios.post(`/bottlereturn/createreturn`, values);

  callback(res.data.response);
};

export const updateBottleReturn = async (id, values, callback) => {
  const res = await axios.put(`/bottlereturn/updatereturn/${id}`, values);

  if (res.status === 200) {
    callback(res.data.response);
  } else {
    callback(res.data.response);
  }
};

export const deleteBottleReturn = async (id, values, callback) => {
  const res = await axios.put(`/bottlereturn/deletereturn/${id}`, { updatedBy: values });

  callback(res.data.response);
};

export const getAllBottleReturn = async (rowPerPage, pageNumber, search, callback) => {
  const res = await axios.get(`/bottlereturn/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);

  callback(res.data.response);
};

export const getBottleReturnById = async (id, callback) => {
  await axios
    .get(`/bottlereturn/byid/${id}`)
    .then((res) => {
      callback(res.data.response);
    })
    .catch((err) => {
      console.log("Get Bottle Return By Id Error : ", err);
    });
};

export const getAllBottleReturnBalance = async (callback) => {
  await axios
    .get(`/bottlereturn/returnbalance`)
    .then((res) => {
      callback(res.data.response);
    })
    .catch((err) => {
      console.log("Get Bottle Return Balance Error : ", err);
    });
};

export const BottleReturnAPI = () => {
  const [bottleReturns, setBottleReturns] = useState([]);
  const [bottleReturnDetail, setBottleReturnDetail] = useState({});
  const [bottleBalances, setBottleBalances] = useState([]);

  const [rowPerPage, setRowPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [callback, setCallback] = useState(false);
  const [bottleReturnId, setBottleReturnId] = useState(0);

  const isUser = localStorage.getItem("login");

  useEffect(() => {
    if (!isUser) return;

    const fetchData = async () => {
      try {
        const bottleData = await new Promise((resolve) => getAllBottleReturn(rowPerPage, pageNumber, search, resolve));
        setBottleReturns(bottleData);
        setTotalPages(bottleData.totalPages || 1);

        if (bottleReturnId) {
          const bottleReturnData = await new Promise((resolve) => getBottleReturnById(bottleReturnId, resolve));
          setBottleReturnDetail(bottleReturnData.data);
        }

        const bottleReturnList = await new Promise((resolve) => getAllBottleReturnBalance(resolve));
        setBottleBalances(bottleReturnList.data);
      } catch (err) {
        console.error("Error fetching roles: ", err);
      }
    };

    fetchData();
  }, [callback, rowPerPage, search, pageNumber, bottleReturnId, isUser]);

  return {
    bottleReturns: [bottleReturns, setBottleReturns],
    bottleReturnDetail: [bottleReturnDetail, setBottleReturnDetail],
    bottleBalances: [bottleBalances, setBottleBalances],
    bottleReturnId: [bottleReturnId, setBottleReturnId],
    rowPerPage: [rowPerPage, setRowPerPage],
    search: [setSearch],
    pageNumber: [pageNumber, setPageNumber],
    totalPages: [totalPages, setTotalPages],
    callback: [callback, setCallback],
  };
};
